import { z } from 'zod'
import { apiReferenceSchema, apiReferenceSchemaWithVersions } from './api-reference'
import { guideSchema, ParsedGuideWithVersionsConfig } from './guide'

export const configSchema = z.discriminatedUnion('variant', [guideSchema, apiReferenceSchema])

export type ParsedAPIReferenceWithVersionsConfig = z.infer<typeof apiReferenceSchemaWithVersions>
export type ParsedAPIReferenceConfig = z.infer<typeof apiReferenceSchema>
export type ParsedConfig = z.infer<typeof configSchema>
export type ParsedConfigWithVersions =
	| ParsedGuideWithVersionsConfig
	| ParsedAPIReferenceWithVersionsConfig

export type GuideVariant = ParsedConfig['variant']

export * from './api-reference'
export * from './guide'
export * from './page-content'
export * from './shared'
export * from './sidebar'
